/**
 * Grenade Points — canje y copiar códigos
 */
(function () {
  'use strict';

  var REDEEM_KEY = 'mg-redeemed';

  function storageKey() {
    if (window.MG_CUSTOMER && window.MG_CUSTOMER.id) return REDEEM_KEY + '-' + window.MG_CUSTOMER.id;
    return REDEEM_KEY + '-guest';
  }

  function getRedeemed() {
    try {
      return JSON.parse(localStorage.getItem(storageKey()) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveRedeemed(list) {
    try {
      localStorage.setItem(storageKey(), JSON.stringify(list));
    } catch (e) {}
  }

  function copyText(text, btn) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        if (btn) {
          var orig = btn.textContent;
          btn.textContent = '¡Copiado!';
          setTimeout(function () { btn.textContent = orig; }, 2000);
        }
      });
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
  }

  document.addEventListener('click', function (e) {
    var copyBtn = e.target.closest('[data-mg-copy-code]');
    if (copyBtn) {
      e.preventDefault();
      copyText(copyBtn.getAttribute('data-code'), copyBtn);
      return;
    }

    var redeemBtn = e.target.closest('[data-mg-redeem]');
    if (!redeemBtn || redeemBtn.disabled) return;
    e.preventDefault();

    var id = redeemBtn.getAttribute('data-redeem-id');
    var code = redeemBtn.getAttribute('data-code');
    var cost = parseInt(redeemBtn.getAttribute('data-cost'), 10);
    var points = parseInt(redeemBtn.getAttribute('data-points'), 10);
    var redeemed = getRedeemed();

    if (redeemed.indexOf(id) >= 0) return;
    if (points < cost) {
      alert('No tienes suficientes Grenade Points para este canje.');
      return;
    }

    if (!confirm('¿Canjear ' + cost + ' puntos por ' + redeemBtn.getAttribute('data-title') + '?')) return;

    redeemed.push(id);
    saveRedeemed(redeemed);

    var card = redeemBtn.closest('[data-redeem-card]');
    if (card) {
      card.classList.add('is-redeemed');
      var reveal = card.querySelector('[data-redeem-reveal]');
      if (reveal) reveal.hidden = false;
      redeemBtn.disabled = true;
      redeemBtn.textContent = 'Canjeado';
    }

    copyText(code, card && card.querySelector('[data-mg-copy-code]'));
  });

  function initRedeemCards() {
    var redeemed = getRedeemed();
    document.querySelectorAll('[data-redeem-card]').forEach(function (card) {
      var id = card.getAttribute('data-redeem-id');
      if (redeemed.indexOf(id) >= 0) {
        card.classList.add('is-redeemed');
        var reveal = card.querySelector('[data-redeem-reveal]');
        if (reveal) reveal.hidden = false;
        var btn = card.querySelector('[data-mg-redeem]');
        if (btn) { btn.disabled = true; btn.textContent = 'Canjeado'; }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initRedeemCards);
  initRedeemCards();
})();